// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"25b2a0c7","573":"bff48523","643":"fe652161"}[chunkId] + ".chunk.js";
};